import React, { useEffect, useMemo, useState } from "react";

function formatTime(date, timezone, format) {
  const zone = timezone || undefined;

  if (format === "HH:mm:ss A" || format === "HH:mm") {
    const withSeconds = format === "HH:mm:ss A";
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: withSeconds ? "2-digit" : undefined,
      hour12: true,
      timeZone: zone,
    }).format(date);
  }

  return date.toLocaleTimeString("en-US", { timeZone: zone });
}

export default function LiveClock({
  format = "HH:mm",
  ticking = false,
  timezone = null,
  element = "time",
  className,
  style,
}) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!ticking) {
      return undefined;
    }

    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, [ticking]);

  const value = useMemo(() => formatTime(now, timezone, format), [now, timezone, format]);
  const Element = element;

  return <Element className={className} style={style}>{value}</Element>;
}
